import { DatePickerValue, DateType } from 'component/UI/DatePicker'
import moment from 'moment'

/**
 * @description
 * Converts date value type from components/UI/DatePicker to startDate & endDate
 * @see components/UI/DatePicker
 * @author AmirAdal
 */
const convertToFilterDate = (
	date: DatePickerValue
): { startDate: string; endDate: string; dateType: DateType } => {
	const { value } = date
	switch (date.type) {
		case 'day':
			return {
				dateType: date.type,
				startDate: moment(value).startOf('day').toJSON(),
				endDate: moment(value).endOf('day').toJSON(),
			}
		case 'month':
			return {
				dateType: date.type,
				startDate: moment(value).startOf('month').toJSON(),
				endDate: moment(value).endOf('month').toJSON(),
			}
		case 'quarter':
			return {
				dateType: date.type,
				startDate: moment(value).startOf('quarter').toJSON(),
				endDate: moment(value).endOf('quarter').toJSON(),
			}
		case 'year':
			return {
				dateType: date.type,
				startDate: moment(value).startOf('year').toJSON(),
				endDate: moment(value).endOf('year').toJSON(),
			}
		case 'range':
			return {
				dateType: date.type,
				startDate: moment(value[0]).startOf('day').toJSON(),
				endDate: moment(value[1]).endOf('day').toJSON(),
			}
		case 'week':
			return {
				dateType: date.type,
				startDate: moment(value).startOf('week').toJSON(),
				endDate: moment(value).endOf('week').toJSON(),
			}
		default:
			return {
				dateType: date.type,
				startDate: moment().startOf('day').toJSON(),
				endDate: moment().endOf('day').toJSON(),
			}
	}
}

export default convertToFilterDate
